export const STAFF_ROLES = {
  DOCTOR: "doctor",
  ADMINISTRATION: "administration"
}